// extracted by mini-css-extract-plugin
export var text = "_t-0";